import { createRouter, createWebHashHistory } from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import CleanLayout from '@/layouts/Hiperfarma.vue'

const routes = [
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: AuthLayout,
        meta: {
          title: 'LOGIN',
        },
      },
    ],
  },
  {
    path: '/pedido-farmacias/:campanha_id/:farmacia_matriz_id',
    name: 'Lista de Pedidos de Filiais',
    meta: {},
    component: () => import('@/views/hiperfarma_campanhas/pedido/List.vue'),
  },
  {
    path: '/pedido-form',
    name: 'Pedido Form',
    meta: {},
    component: () => import('@/views/hiperfarma_campanhas/pedido/Form.vue'),
  },
  {
    path: '/historico-pedidos/:farmacia_matriz_id',
    name: 'Historico de Pedidos',
    meta: {},
    component: () =>
      import('@/views/hiperfarma_campanhas/pedido/Historico.vue'),
  },
  {
    path: '/hiperfarma',
    name: 'Campanhas Hiperfarma',
    redirect: '/campanhas-hiperfarma',
    component: CleanLayout,
    children: [
      {
        path: '/campanhas-hiperfarma',
        name: 'Campanhas Hiperfarma',
        component: () =>
          import('@/views/hiperfarma_campanhas/campanha/List.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('token')
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
